import _assertString2 from "./util/assertString";
import _merge2 from "./util/merge";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmpty;
var _assertString = _interopRequireDefault(_assertString2);
var _merge = _interopRequireDefault(_merge2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var default_is_empty_options = {
  ignore_whitespace: false
};
function isEmpty(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_is_empty_options);
  return (options.ignore_whitespace ? str.trim().length : str.length) === 0;
}
exports = exports.default;
exports.default = exports.default;
export default exports;
export const __esModule = exports.__esModule;